import { GenericPage } from "../components/common/GenericPage";
import {
  speciesCollapseTableFields,
  speciesTableFields,
} from "../utils/table-fields/speciesTableFields";

export const AllSpecies = () => {
  return (
    <GenericPage
      title="All Species"
      subtitle="Xenobiological classification archive"
      parentQuery="allSpecies"
      childQuery="species"
      tableFields={speciesTableFields}
      collapseFields={speciesCollapseTableFields}
    />
  );
};
